export const jobs = {
  listing: {
    title: 'Job Offers',
    subtitle: 'Discover the best career opportunities',
    results: 'results',
    noResults: 'No offers match your criteria',
    noResultsDesc: 'Try modifying your filters to see more offers',
    clearFilters: 'Clear filters',
    loadMore: 'Load more offers',
    filters: {
      title: 'Filters',
      keywords: 'Keywords',
      keywordsPlaceholder: 'Job title, skills...',
      location: 'Location',
      locationPlaceholder: 'City, region...',
      category: 'Category',
      categoryAll: 'All categories',
      contractType: 'Contract type',
      contractAll: 'All types',
      search: 'Search',
      reset: 'Reset'
    },
    categories: {
      it: 'IT & Tech',
      marketing: 'Marketing & Communication',
      sales: 'Sales & Commerce',
      finance: 'Finance & Accounting',
      hr: 'Human Resources',
      engineering: 'Engineering',
      healthcare: 'Healthcare',
      education: 'Education',
      logistics: 'Logistics',
      other: 'Other'
    },
    contracts: {
      cdi: 'Permanent',
      cdd: 'Fixed-term',
      stage: 'Internship',
      freelance: 'Freelance',
      alternance: 'Work-study'
    }
  },
  detail: {
    applyNow: 'Apply now',
    share: 'Share',
    saved: 'Saved',
    save: 'Save',
    description: 'Job description',
    requirements: 'Requirements',
    benefits: 'Benefits',
    company: 'About the company',
    location: 'Location',
    contractType: 'Contract type',
    salary: 'Salary',
    experience: 'Experience',
    education: 'Education',
    postedOn: 'Posted on',
    expiresOn: 'Expires on',
    similarJobs: 'Similar jobs',
    backToList: 'Back to offers'
  }
};